import {Outlet} from '@github-ui/react-router'

import {IssuesVersionMismatchToast} from '../components/IssuesVersionMismatchToast'

/**
 * Parent route for the data-router `issues` app. Every leaf (labels, milestone
 * new/index/edit) owns its own `RepoIssuesPageLayout`, so this parent is a pure
 * passthrough — it only exists to host the shared issues-layout route query that
 * the leaves read via `useRouteQuery(issuesLayoutRoute, ...)`, and to register the
 * version mismatch toast for every Issues leaf.
 *
 * Keep it a passthrough: wrapping `Outlet` in any element, even a bare context provider, makes
 * `saved-views` fetch on first paint. Its test is the guard, and names neither this file nor why.
 * The toast registration renders nothing and sits beside `Outlet`, not around it.
 */
export function IssuesLayout() {
  return (
    <>
      <IssuesVersionMismatchToast />
      <Outlet />
    </>
  )
}
